import React, { Component } from 'react';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';
import styled from 'styled-components';

const CountWrapper = styled.div`
  font-size: 44px;
  text-align: center;
`;

const CountParent = styled.div`
  display: flex;
  flex-direction: column;
  width: 160px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
`;

const CountText = styled.div`
  text-align: center;
`;

const Counters = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  @media only screen and (max-width: 800px) {
    flex-direction: column;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }
`;

class App extends Component {
  state = {
    didViewCountUp: false,
  };

  onVisibilityChange = isVisible => {
    if (isVisible) {
      this.setState({ didViewCountUp: true });
    }
  };

  render() {
    return (
      <Counters>
        <VisibilitySensor
          onChange={this.onVisibilityChange}
          offset={{
            top: 10,
          }}
          delayedCall
        >
          <CountParent>
            <CountWrapper>
              <CountUp
                decimals={0}
                start={0}
                end={this.state.didViewCountUp ? 513 : 0}
                suffix="k+"
                duration={3}
              />
            </CountWrapper>
            <CountText>WORKFORCE</CountText>
          </CountParent>
        </VisibilitySensor>
        <CountParent>
          <CountWrapper>
            <CountUp
              decimals={0}
              start={0}
              end={this.state.didViewCountUp ? 871 : 0}
              suffix="k+"
              duration={3}
            />
          </CountWrapper>
          <CountText>GIGS COMPLETED</CountText>
        </CountParent>
        <CountParent>
          <CountWrapper>
            <CountUp
              decimals={0}
              start={0}
              end={this.state.didViewCountUp ? 76 : 0}
              suffix="k+"
              duration={3}
            />
          </CountWrapper>
          <CountText>TIME SAVED (HOURS)</CountText>
        </CountParent>
        <CountParent>
          <CountWrapper>
            <CountUp
              decimals={0}
              start={0}
              end={this.state.didViewCountUp ? 34 : 0}
              suffix="+"
              duration={3}
            />
          </CountWrapper>
          <CountText>CITIES</CountText>
        </CountParent>
      </Counters>
    );
  }
}

export default App;
